module.exports = __webpack_public_path__ + "img/introduce03.866ee46c.png";